import { render, staticRenderFns } from "./ChoujianWorkbench.vue?vue&type=template&id=97eafa10&scoped=true"
import script from "./ChoujianWorkbench.vue?vue&type=script&lang=js"
export * from "./ChoujianWorkbench.vue?vue&type=script&lang=js"
import style0 from "./ChoujianWorkbench.vue?vue&type=style&index=0&id=97eafa10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97eafa10",
  null
  
)

export default component.exports